<template>
  <div class="edit-studio-container">

    <main class="tab-content">

      <h2 class="item text-secondary">Menu content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec array-links">
          <label>Menu items:</label>
          <div class="field-sec flex menu-items" v-for="item, i in fit20.blockToEdit.menu_items">
            <div class="field-sec flex">
              <label>Text {{ i + 1 }}:</label>
              <input type="text" class="form-control" v-model="item.item_name" />
            </div>
            <div class="field-sec flex">
              <label>Link {{ i + 1 }}:</label>
              <input type="text" class="form-control" v-model="item.item_link" />

            </div>
            <!-- Move Up Button -->
            <span class="up-down" @click="moveItem(i, -1)" v-if="i !== 0 && item.item_name">⬆️</span>
            <div class=" flex" v-if="item.item_name">
              <label>New window {{ i + 1 }}:</label>
              <select v-model="item.new_window" :class="{ 'yes-class': item.new_window, 'no-class': !item.new_window }">
                <option :value=true>Yes</option>
                <option :value=false>No</option>
              </select>
            </div>
            <div class=" flex" v-if="item.item_name">
              <label>Pink {{ i + 1 }}:</label>
              <select v-model="item.pink_btn" :class="{ 'yes-pink-class': item.pink_btn, 'no-class': !item.pink_btn }">
                <option :value=true>Yes</option>
                <option :value=false>No</option>
              </select>
            </div>
            <!-- Move Down Button -->
            <span class="up-down" @click="moveItem(i, 1)"
              v-if="i !== fit20.blockToEdit.menu_items.length - 1 && item.item_name">
              ⬇️
            </span>
          </div>
        </div>
        <div class=" flex field-sec" v-if="multiLang">
          <label>Multi languages :</label>
          <select v-model="fit20.blockToEdit.multi_lang">
            <option :value=true>Yes</option>
            <option :value=false>No</option>
          </select>
        </div>
        <div class="fake-div"></div>

        <div v-for="langKey, i in fit20.blockToEdit.multi_lang_items" :key="langKey.lang_code" class="languages">
          <div class=" flex field-sec" v-if="langKey.lang_code && fit20.blockToEdit.multi_lang">
            <label>{{ "Language code : " + langKey.lang_code }} -- Language name:</label>
            <input type="text" class="form-control" v-model="fit20.blockToEdit.multi_lang_items[i].lang_name" />
          </div>
          <div class=" flex field-sec" v-if="langKey.lang_code && fit20.blockToEdit.multi_lang">
            <label>Default language :</label>
            <select v-model="fit20.blockToEdit.multi_lang_items[i].default">
              <option :value=true>Yes</option>
              <option :value=false>No</option>
            </select>
          </div>
          <div class=" flex field-sec" v-if="langKey.lang_code && fit20.blockToEdit.multi_lang">
            <label>Active :</label>
            <select v-model="fit20.blockToEdit.multi_lang_items[i].active">
              <option :value=true>Yes</option>
              <option :value=false>No</option>
            </select>
          </div>
        </div>

        <div class="field-sec " v-if="fit20.selectedTabHref != 'studio'">
          <label>Home page :</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.site_homepage" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref == 'studio'">
          <label>Studio contact page :</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.contactPage" />
        </div>
        <div class="field-sec ">
          <label>Search page:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.search_page" />
        </div>
        <div class="field-sec" v-if="fit20.selectedTabHref != 'studio'">
          <label>Google tag manager code:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.google_tag" />
          <input type="text" class="form-control" v-model="fit20.blockToEdit.google_tag2" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref != 'studio'">
          <label>Facebook pixel code:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.meta_pixel" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref != 'studio'">
          <label>Google ad code:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.google_ad" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref == 'country'">
          <label>Cookie text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cookie_cp_text" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref == 'country'">
          <label>Cookie URL text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cookie_cp_url_label" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref != 'studio'">
          <label>Cookie policy URL:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cookie_url" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref == 'country'">
          <label>Settings text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cookie_settings" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref == 'country'">
          <label>Necessary text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cookie_necessary" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref == 'country'">
          <label>Marketing text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cookie_marketing" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref == 'country'">
          <label>Functional text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cookie_functional" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref == 'country'">
          <label>Analytics text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cookie_analytics" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref == 'country'">
          <label>Save text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cookie_save" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref == 'country'">
          <label>Accept text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cookie_accept_btn_text" />
        </div>
        <div class="field-sec " v-if="fit20.selectedTabHref == 'country'">
          <label>Accept only necessary cookies text :</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cookie_decline_btn_text" />
        </div>

      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>
      <div class="menu-container">
        <div id="menuRoot" class="zpheader-style-01 fit20-main-menu">
          <div id="fit20_menu_logo" class="fit20-menu-logo">
            <a id="site_URL" href=""><img id="site_URL_img" data-zs-logo=""
                src="https://www.fit20.com/files/images/Global/Global Logos/fit20-logo.png" alt="fit20"
                style="height: 81px; width: 280px" /></a>
          </div>
          <div class="menu-right-content not-fixed">
            <div class="burger-container burger-container-close display-none">
              <button id="burger_menu" class="burger-menu burger-menu-close">
                <span class="burger-menu-span"></span>
              </button>
            </div>
            <div id="menu_search_box" class="menu-search-box">
              <input id="menu_search_field" class="menu-search-field display-none" type="search" placeholder="" />
              <i class="fa fa-fw fa-search" onclick="" style="font-size: 20px"></i>
            </div>
            <div id="menu_div" class="fit20-navigation-and-icons">
              <ul id="menu" data-zs-menu-container="" data-zp-menu-top="">
                <li v-for="item in fit20.blockToEdit.menu_items" :class="item.pink_btn ? 'free-try' : ''">
                  <a v-if="item.item_link" href='#'>
                    {{ item.item_name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'Menu',
  props: ["fit20", "saveBlock", "cancelEditing"],
  data() {
    return {
      activeCountryLangs: '',
    }

  },
  methods: {
    moveItem(index, direction) {
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= this.fit20.blockToEdit.menu_items.length) {
        return;
      }

      // Swap items in the array
      const items = [...this.fit20.blockToEdit.menu_items];
      [items[index], items[newIndex]] = [items[newIndex], items[index]];

      // Assign new array to trigger reactivity
      this.fit20.blockToEdit.menu_items = items;
    }
  },
  computed: {
    multiLang() {
      let country = this.fit20.countries.find(country => country.name == this.fit20.activeCountry);
      console.log(country);
      this.activeCountryLangs = Object.keys(country.sites);
      if (country && country.sites && Object.keys(country.sites).length > 1) {
        this.activeCountryLangs.forEach(code => {
          let langObject = this.fit20.blockToEdit.multi_lang_items.find(ele => ele.lang_code == code);
          if (!langObject) {
            this.fit20.blockToEdit.multi_lang_items.push({
              lang_name: '', lang_code: code, active: false, default: false
            })
          }
          this.fit20.blockToEdit.multi_lang_items = this.fit20.blockToEdit.multi_lang_items.filter(ele => ele.lang_code);
        });

        return true
      } else {
        return false
      }
    }
  },
  created() {
    // console.log(this.activeCountry);
  }

};
</script>

<style scoped>
.languages {
  padding: 20px;
  box-shadow: 0 0 5px rgb(207, 207, 207);
  border-radius: 10px;
  margin: 5px 0;
}

.up-down {
  cursor: pointer;
}

.yes-class {
  color: white;
  background-color: var(--fit20-green);
}

.yes-pink-class {
  color: white;
  background-color: var(--fit20-pink);
}

.menu-items {
  /* margin: 0;
  margin-bottom: 10px;
  width: 100% !important; */
  width: 95% !important;
  box-shadow: 0 0 2px;
  margin: 5px 20px;
  border-radius: 5px;
  padding: 5px;
}

.menu-items select {
  width: 65%;
}

.menu-items label {
  width: 35%;
  padding: 0px 0px 0px 10px;
}

.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.menu-items input {
  width: 65%;
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/* example css */

.lock-scroll {
  overflow: hidden;
}

.menu-container {
  max-width: 1500px !important;
  margin: 0 auto !important;
  position: relative !important;
  padding-right: 20px;
}

.fit20-main-menu {
  width: 100% !important;
  max-width: 1500px !important;
  height: 81px !important;
  margin: 0 auto !important;
  color: #616365 !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  transition: width 0.7s !important;
  background-color: white !important;
  margin-left: auto !important;
  right: 0 !important;
  z-index: 9999999 !important;
}

.close {
  justify-content: center !important;
  width: 60px !important;
  height: 60px !important;
  transition: width 0.7s !important;
  margin: 0 !important;
  position: absolute !important;
  right: 10px !important;
  top: 10px !important;
  margin-left: auto !important;
}

.radius {
  border-radius: 50% !important;
  transition: all 0.7s !important;
}

.display-none {
  display: none !important;
}

.studio-name-margin {
  margin-top: 75px !important;
  transition: all 0.7s !important;
}

.studio-name-fix-margin {
  margin-top: 0px !important;
  transition: all 0.5s !important;
}

body div.menu-search-box {
  margin: 12px 10px auto 0 !important;
  line-height: normal !important;
}

.menu-search-box-design {
  width: 20%;
  margin-left: 10px;
  background-color: #ffffff !important;
  border: solid 1px #494b5326 !important;
  border-radius: 30px !important;
  height: 30px !important;
  padding-left: 10px;
}

.menu-search-box i {
  cursor: pointer !important;
  color: #009df4 !important;
}

.menu-search-box input {
  width: 78% !important;
  font-size: 15px !important;
  border: none !important;
  background-color: transparent !important;
  color: #494b53 !important;
  outline: rgb(0, 159, 227) !important;
  border-radius: 30px !important;
  background-color: white !important;
  padding: 0px 0px 0px 5px !important;
  line-height: normal !important;
}

.fit20-main-menu ul {
  list-style: none !important;
}

.fit20-main-menu li {
  margin-right: 15px !important;
}

.mobile-menu {
  display: none !important;
}

li.theme-menu-selected {
  color: #009df4 !important;
  background-color: white !important;
}

.fit20-main-menu li a,
.fit20-main-menu li a:link,
.fit20-main-menu li a:visited,
.fit20-main-menu li span {
  text-decoration: none !important;
  color: #616365 !important;
  font-size: 14px !important;
}

.fit20-main-menu li a:hover,
.fit20-main-menu li span:hover {
  color: #009df4 !important;
}

li.free-try a,
li.free-try a:link,
li.free-try a:visited {
  padding: 5px 8px;
  background-color: #e5007d !important;
  color: white !important;
  border-radius: 20px !important;
  border: solid 1px #e5007d !important;
}

li.free-try a:hover {
  background-color: #ffffff !important;
  color: #e5007d !important;
  transition: all 0.5s;
}

.fit20-down-arrow {
  transform: rotate(90deg) !important;
  display: inline-block !important;
  margin-left: 2px !important;
}

#menu {
  display: flex !important;
}

.burger-container {
  text-align: center !important;
  padding: 10px 15px !important;
  box-shadow: 0 0 1px gray;
  border-radius: 50%;
  background: white;
}

.burger-menu {
  text-align: center !important;
  border: none !important;
  background: none !important;
  width: 20px !important;
  height: 24px !important;
  position: relative !important;
  padding: 0 !important;
  transition: opacity 0.5s ease !important;
  outline: none !important;
}

.burger-menu:hover {
  opacity: 1 !important;
}

.menu-right-content {
  display: flex !important;
  width: 100%;
  flex-direction: row-reverse;
}

.burger-menu-span {
  display: block;
  width: 100%;
  height: 3px;
  position: absolute;
  top: 0;
  left: 0;
  border-top: 3px solid #616365;
  transform: translateY(10px);
  transition: transform 0.5s ease, border-color 0.5s ease 0.3s;
}

.burger-menu-span:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: #616365;
  transform: translateY(-10px);
  animation-name: topLineBurger;
  animation-duration: 0.6s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: forwards;
}

.burger-menu-span:after {
  content: '';
  position: absolute;
  top: -6px;
  left: 0;
  width: 100%;
  height: 3px;
  background: #616365;
  transform: translateY(10px);
  animation-name: bottomLineBurger;
  animation-duration: 0.6s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: forwards;
}

.opened {
  height: 28px !important;
}

.opened .burger-menu-span {
  border-color: transparent;
  transition: border-color 0.3s ease;
}

.opened .burger-menu-span:before {
  animation-name: topLineCross;
  animation-duration: 0.6s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: forwards;
}

.opened .burger-menu-span:after {
  top: 0;
  animation-name: bottomLineCross;
  animation-duration: 0.6s;
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  animation-fill-mode: forwards;
}

@keyframes topLineCross {
  0% {
    transform: translateY(-10px);
  }

  50% {
    transform: translateY(0px);
  }

  100% {
    transform: translateY(0px) rotate(45deg);
  }
}

@keyframes bottomLineCross {
  0% {
    transform: translateY(10px);
  }

  50% {
    transform: translateY(0px);
  }

  100% {
    transform: translateY(0px) rotate(-45deg);
  }
}

@keyframes topLineBurger {
  0% {
    transform: translateY(0px) rotate(45deg);
  }

  50% {
    transform: rotate(0deg);
  }

  100% {
    transform: translateY(-10px) rotate(0deg);
  }
}

@keyframes bottomLineBurger {
  0% {
    transform: translateY(0px) rotate(-45deg);
  }

  50% {
    transform: rotate(0deg);
  }

  100% {
    transform: translateY(10px) rotate(0deg);
  }
}

/* for dropdown menu */
.dropdown {
  position: relative !important;
  display: inline-block !important;
}

.dropdown-content {
  display: none !important;
  position: absolute !important;
  background-color: #ffffff !important;
  width: fit-content !important;
  overflow: auto !important;
  border: 1px solid #ddd !important;
  border-radius: 10px !important;
  z-index: 1 !important;
}

.dropdown-content a {
  color: black !important;
  padding: 5px 16px !important;
  text-decoration: none !important;
  display: block !important;
}

.dropdown a:hover {
  background-color: #ddd !important;
}

#zpcookie-banner {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  box-shadow: 0 5px 30px gray;
  border-radius: 20px;
}

.zpcookie-banner-bottom {
  inset-block-end: auto !important;
}

.zpcookie-banner-bottom,
.zpcookie-banner-top {
  width: 80% !important;
  max-width: 900px !important;
  padding: 30px !important;
}

.show {
  display: block !important;
}

.category {
  align-items: center;
  justify-content: space-evenly;
  display: flex;
  width: 100%;
  margin-bottom: 20px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

.cookie-settings-popup {
  background-color: #efefef;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  z-index: 99999999999999999999999999;
  width: 80%;
  border-radius: 15px;
  border: solid 1px rgba(128, 128, 128, 0.363);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 0;
}

.cookie-settings-popup input:disabled+.slider {
  background-color: #cacaca;
}

.cookie-settings-popup input:checked+.slider {
  background-color: #92d400;
}

.cookie-settings-popup input:disabled+.slider {
  background-color: #009df4;
}

.cookie-settings-popup input:checked+.slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.save-btn {
  padding: 10px 20px;
  background-color: #92d400;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 10px;
}

.cookie-settings-popup .category label:first-of-type {
  width: 260px;
}

.zpcookie-action-links {
  color: #009fe3;
  cursor: pointer;
}

.zpcookie-action-links:hover {
  color: #92d400;
}

@media only screen and (max-width: 1030px) {
  body div.menu-search-box {
    margin: 10px auto !important;
  }

  #menu {
    width: 100%;
    background: white;
    padding-bottom: 20px !important;
  }

  .burger-container {
    display: block;
  }

  .fit20-main-menu {
    width: 200px !important;
    height: fit-content !important;
    position: absolute;
    margin: 0 !important;
    flex-direction: column !important;
    margin-left: auto !important;
    right: 0 !important;
    z-index: 9999;
  }

  .close {
    justify-content: center !important;
    width: 46px !important;
    height: 46px !important;
    margin: 0 !important;
    position: absolute !important;
    right: 10px !important;
  }

  .studio-name-margin {
    margin-top: 0 !important;
  }

  .fit20-menu-logo {
    display: none !important;
  }

  .menu-right-content {
    flex-direction: column !important;
    width: 100% !important;
  }

  #menu {
    flex-direction: column !important;
  }

  .menu-search-box {
    width: 80%;
    margin: 0 auto !important;
    margin-left: 10px;
    background-color: #ffffff !important;
    border: solid 1px #494b5326 !important;
    border-radius: 30px !important;
    height: 25px !important;
  }

  .menu-search-box input {
    width: 75% !important;
    font-size: 15px !important;
    border: none !important;
    background-color: transparent !important;
    color: #494b53 !important;
    outline: none !important;
    border-radius: 30px !important;
    background-color: white !important;
    padding: 0 0 0 5px !important;
  }

  .menu-search-field {
    display: inline !important;
  }

  .fit20-main-menu ul {
    padding: 0 !important;
    padding-left: 20px !important;
  }

  .fit20-main-menu li {
    margin-right: 0px !important;
    margin-top: 10px !important;
  }

  .burger-container {
    direction: rtl !important;
    text-align: right !important;
    margin: 0 !important;
  }

  .burger-menu {
    text-align: left !important;
  }

  .burger-container-close {
    text-align: center !important;
    margin: auto !important;
  }

  .burger-menu-close {
    text-align: center !important;
  }
}

@media only screen and (max-width: 650px) {
  .cookie-settings-popup .category label:first-of-type {
    font-size: 13px !important;
    width: 210px;
  }
}
</style>
